module.exports = __webpack_public_path__ + "static/img/dialog.47f02a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/christmax/dialog.png
// module id = 896
// module chunks = 2